import Chart from 'chart.js/auto';
import ChartDataLabelsPlugin from 'chartjs-plugin-datalabels';

import { fetchGalleryImages } from "./galleryScript.js";

const galleryContainer = document.getElementById('gallery-container');
const statisticsContainer = document.getElementById('statistics-container');
const ageChartCanvas = document.getElementById('age-chart-canvas');
const genderChartCanvas = document.getElementById('gender-chart-canvas');
const localsChartCanvas = document.getElementById('locals-chart-canvas');
const visitorsChartCanvas = document.getElementById('visitors-chart-canvas');
const participantCountSpan = document.getElementById('participant-count');
const questionText = document.querySelector('.question-text');
const themesContainer = document.querySelector('.themes-scroll-container .scroll-area');
const themesSortButton = document.getElementById('themes-sort-button');
const themesHeaderLabel = document.getElementById('themes-header-label');
const statisticsTab = document.querySelector('.tab-container .tab:first-child');
const galleryTab = document.querySelector('.tab-container .tab:last-child');

const likesChartsHost = document.getElementById('likes-charts');
const LIKES_ENDPOINT = 'https://publictwin.info/EngagementAppPrototypes/PlacKrakowskiPHP/Get_Likes_Summary_PlacKrakowski.php';

let likesCharts = [];
let likesSummaryRows = []; // [{configuration_id, zone_id, cnt}]
window.__likesCharts = likesCharts;
let resultsObserver = null;

let ageData = [
    { ageGroup: "1-14", count: 5 },
    { ageGroup: "15-24", count: 15 },
    { ageGroup: "25-34", count: 20 },
    { ageGroup: "35-44", count: 12 },
    { ageGroup: "45-54", count: 10 },
    { ageGroup: "55-70", count: 20 },
    { ageGroup: "70+", count: 2 }
];

let genderData = [
    { gender: "kobieta", count: 60 },
    { gender: "mężczyzna", count: 32 },
    { gender: "inna", count: 10 },
    { gender: "wolę nie mówić", count: 8 },

];

let placeRelationData = {
    localParticipantsCity: 25,
    localParticipantsNeighbourhood: 45,
    otherVisitors: 10,
};

const questionsData = [
    {
        question: "What's important for you in Groningen?", replies: 26, sentiment: [60, 25, 15],
        themes: [34, 26, 20, 15, 10, 8, 5, 3, 2, 1]
    },
    {
        question: "What do you like about Groningen?", replies: 35, sentiment: [75, 20, 5],
        themes: [19, 35, 3, 9, 10, 8, 15, 3, 2, 4]
    },
    {
        question: "What would you improve in Groningen?", replies: 16, sentiment: [40, 45, 15],
        themes: [30, 25, 20, 11, 10, 5, 3, 2, 5]
    },
];

const themeNames = [
    "Accessibility",
    "Housing",
    "Economy",
    "Leisure",
    "Heritage",
    "Mobility",
    "Biodiversity",
    "Climate",
    "Tourism",
    "Safety"
];

const norm = (s) =>
    (s ?? '')
        .toString()
        .normalize('NFKC')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();


const sourceChartCanvas = document.getElementById('source-chart-canvas');

let answersSourceData = [
    { label: 'online', count: 0 },
    { label: 'form', count: 0 },
];

let sourceChart;


// accepted labels (normalize to be safe)
const NEIGHBOR_LABELS = [
  'mieszkam w pobliżu pl.krak.',
  'mieszkam w poblizu pl.krak.',   // no diacritics fallback (just in case)
  'mieszkam w pobliżu pl krak',    // without dot
  'mieszkam w pobliżu placu krakowskiego',
].map(norm);

const CITY_LABELS = [
  'mieszkam w gliwicach'
].map(norm);



function getZoneIdsFromParticipation() {
  const zones = (window.participationZones || []);
  const ids = zones
    .map(z => {
      const m = String(z.id || '').match(/\d+/);
      return m ? parseInt(m[0], 10) : null;
    })
    .filter(n => Number.isFinite(n));
  return Array.from(new Set(ids)).sort((a,b)=>a-b);
}

function determineZoneIds() {
  // 1) jeśli mamy participationZones → użyj
  const fromModel = getZoneIdsFromParticipation();
  if (fromModel.length) return fromModel;

  // 2) inaczej na podstawie danych lajków
  const set = new Set(likesSummaryRows.map(r => Number(r.zone_id)));
  const arr = Array.from(set).filter(Number.isFinite).sort((a,b)=>a-b);
  // 3) fallback (gdy jeszcze nic nie ma)
  return arr.length ? arr : [1,2,3,4,5,6];
}

function zoneLabel(zid) {
  const zones = (window.participationZones || []);
  for (const z of zones) {
    const m = String(z.id || '').match(/\d+/);
    const n = m ? parseInt(m[0],10) : null;
    if (n === zid) return z.displayName || `Strefa ${String(zid).padStart(2,'0')}`;
  }
  return `Strefa ${String(zid).padStart(2,'0')}`;
}

function configIdsList() {
  const opts = (window.PROPOSAL_OPTIONS || []);
  if (opts.length) return opts.map(o => o.configId || 0).filter(Boolean);
  return [1,2,3,4,5]; // fallback
}

function configLabel(cfgId) {
  const o = (window.PROPOSAL_OPTIONS || []).find(x => x.configId === cfgId);
  return o?.label || `Konfiguracja ${cfgId}`;
}

// === Likes label helpers (use global ZONE_LABELS) ============================
function getZoneLikesLabel(cfgId, zoneId) {
  const map = (window.ZONE_LABELS && window.ZONE_LABELS[cfgId]) || null;
  if (!map) return '';
  // Support both numeric keys (1..5) and "Z1".."Z5"
  return map[zoneId] || map['Z' + zoneId] || '';
}

// Results-only labels: configuration_id -> zone_id (1..5) -> text
const ZONE_LABELS_BY_ID = {
  1: { 1:'fontanna, pawilon, targ, dachy nad trybunami', 2:'skwer-skatepark, pergola', 3:'aleja z pomnikiem', 4:'skwer, pawilon, plac zabaw', 5:'plac' },
  2: { 1:'klony, trybuny z siedziskami', 2:'oddolne aktywności', 3:'lapidarium, kawiarnia', 4:'skatepark- skwer', 5:'plac' },
  3: { 1:'klony, długi dach, targ, kawiarnia', 2:'zadaszona przestrzeń aktywności', 3:'gliwickie opowieści', 4:'skatepark - skwer', 5:'plac' },
  4: { 1:'klony, pomosty w koronach drzew, targ', 2:'budynek Centrum Nauki', 3:'kawiarnia, coworking, odpoczynek', 4:'skatepark otwarty, pawilon gastro', 5:'plac' },
  5: { 1:'klony, targ, trybuny, pergole', 2:'sketepark zamknięty', 3:'skwer z pomnikiem', 4:'pawilony gastronomiczne +', 5:'plac, fontanna' }
};
function zoneLikesGraphLabel(cfgId, zoneId) {
  const t = ZONE_LABELS_BY_ID?.[cfgId]?.[zoneId] || '';
  return t ? `Strefa ${zoneId}: ${t}` : `Strefa ${zoneId}`;
}

const zoneShortLabel = (zoneId) => `Strefa ${zoneId}`;


function likesSeriesForConfig(cfgId, zoneIds) {
  return zoneIds.map(zid => {
    const row = likesSummaryRows.find(
      r => Number(r.configuration_id) === Number(cfgId) && Number(r.zone_id) === Number(zid)
    );
    return { zoneId: zid, value: row ? (Number(row.cnt) || 0) : 0 };
  });
}

function computeGlobalLikesMax(cfgIds, zoneIds) {
  let m = 0;
  for (const cfgId of cfgIds) {
    for (const zid of zoneIds) {
      const row = likesSummaryRows.find(
        r => Number(r.configuration_id) === Number(cfgId) && Number(r.zone_id) === Number(zid)
      );
      const v = row ? (Number(row.cnt) || 0) : 0;
      if (v > m) m = v;
    }
  }
  // small headroom for datalabels; fallback to 5 if no data yet
  return m > 0 ? m + Math.ceil(m * 0.05) : 5;
}




// A 15% margin above the highest bar to fit the labels
const placeRelationMaxMargin = 0.15;

let placeRelationLocalSum, placeRelationVisitorsSum, participantCount, placeRelationMax;

function calculatePlaceRelationSums() {


    placeRelationLocalSum = placeRelationData.localParticipantsCity + placeRelationData.localParticipantsNeighbourhood;
    placeRelationVisitorsSum = placeRelationData.otherVisitors;
    console.log("placeRelationVisitorsSum:", placeRelationVisitorsSum);

    placeRelationMax = Math.max(placeRelationLocalSum, placeRelationVisitorsSum) * (1 + placeRelationMaxMargin);

}
function calculateGenderRelationSums(genderData) {
    console.log(genderData);
    participantCount = genderData.reduce((sum, row) => sum + row.count, 0);
    console.log(participantCount);
}


calculateGenderRelationSums(genderData)
// calculatePlaceRelationSums();

const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
        duration: 1000,
        easing: 'easeOutCubic',
    }
};

const placeRelationChartPlugins = {
    datalabels: {
        labels: {
            value: {},
            topLabel: {}
        },
        color: '#1a1818',
        font: {
            size: 20,
            weight: 'bold'
        },
        value: {
            formatter: function (value, _ctx) {
                // Don't show too small values
                if (value < participantCount * 0.1) {
                    return '';
                }
                return value;
            }
        },
        topLabel: {
            anchor: 'end',
            align: 'top',
            offset: 0,
            formatter: function (_value, ctx) {
                if (ctx.datasetIndex !== 1) {
                    // not the top bar
                    return '';
                }

                if (ctx.chart.canvas === localsChartCanvas)
                    return (placeRelationLocalSum * 100 / participantCount).toFixed(0) + '%';
                else return (placeRelationVisitorsSum * 100 / participantCount).toFixed(0) + '%';
            }
        }
    },
    legend: {
        position: 'bottom',
    },
    title: {
        display: true,
        position: 'bottom',
        align: 'center',
        text: 'lokalni odwiedzający',
        color: 'black',
        font: {
            size: 20,
            weight: 'bold'
        },
    }
};

let themes = [];
let themesAscending = false;

function redrawThemes(newThemes) {
    if (newThemes !== undefined) {
        themes = newThemes;
    }

    themesContainer.innerHTML = '';

    themes.sort((a, b) => {
        if (themesAscending) {
            return a.count - b.count;
        }
        return b.count - a.count;
    }).forEach(theme => {
        themesContainer.innerHTML += `
            <div class="theme-row">
                <span class="theme-name">${theme.name}</span>
                <div><span class="theme-count">${theme.count}</span><img src="./res/person.svg" /></div>
            </div>
        `;
    });

    themesHeaderLabel.textContent = themesAscending ? 'Least popular theme: ' : 'Top theme: ';
    themesHeaderLabel.textContent += themes[0].name;
}

let currentTab = null;

export function selectTab(tabName) {
    currentTab = tabName;
    statisticsTab.classList.remove('selected');
    statisticsContainer.classList.remove('hidden');
    galleryTab.classList.remove('selected');
    galleryContainer.classList.remove('hidden');

    if (tabName === 'statistics') {
        statisticsTab.classList.add('selected');
        galleryContainer.classList.add('hidden');
        resultsInitiated();
    } else if (tabName === 'gallery') {
        galleryTab.classList.add('selected');
        statisticsContainer.classList.add('hidden');
        fetchGalleryImages();
    }
}

let charts = [];

function setListeners() {
    const questionButtons = document.querySelectorAll('.question-button');
    questionButtons.forEach((button, index) => {
        button.onclick = () => {
            selectQuestion(index);
        };
    });

    if (themesSortButton !== null) {
        themesSortButton.onclick = () => {
            themesAscending = !themesAscending;
            if (themesAscending) {
                themesSortButton.classList.add('ascending');
            } else {
                themesSortButton.classList.remove('ascending');
            }
            redrawThemes();
        };
    }

    // Select the first question by default
    // selectQuestion(0);

    statisticsTab.onclick = () => {
        selectTab('statistics');
    };
    galleryTab.onclick = () => {
        selectTab('gallery');
    };
}

let lastScrollY = statisticsContainer.scrollTop;

function setObservers() {
  const targets = document.querySelectorAll(".canvas-div");

  // If we re-run, disconnect the previous observer to avoid duplicates.
  if (resultsObserver) {
    resultsObserver.disconnect();
  }

  resultsObserver = new IntersectionObserver((entries) => {
    const scrollingDown = statisticsContainer.scrollTop > lastScrollY;
    lastScrollY = statisticsContainer.scrollTop;

    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      if (!scrollingDown) return;

      const chart = charts.find(c => c.ctx.canvas.parentElement === entry.target);
      if (!chart) return;

      // Reset and update the chart to trigger the animation
      chart.reset();
      chart.update();
    });
  }, {
    root: null,
    threshold: 0.15
  });

  targets.forEach(div => resultsObserver.observe(div));
}

function buildLikesCharts() {
  // wipe old
  const oldLikes = likesCharts.slice();
  charts = charts.filter(ch => !oldLikes.includes(ch));
  oldLikes.forEach(ch => ch.destroy());
  likesCharts = [];
  likesChartsHost.innerHTML = '';

  const zoneIds = determineZoneIds();   // e.g. [1,2,3,4,5]
  const cfgIds  = configIdsList();      // e.g. [1..5]
  const GLOBAL_LIKES_MAX = computeGlobalLikesMax(cfgIds, zoneIds);

  cfgIds.forEach(cfgId => {
    const card = document.createElement('div');
    card.className = 'likes-chart-card';

    const h3 = document.createElement('h3');
    h3.textContent = configLabel(cfgId);

    const wrap = document.createElement('div');
    wrap.className = 'canvas-div tall-chart';

    const canvas = document.createElement('canvas');
    wrap.appendChild(canvas);
    card.appendChild(h3);
    card.appendChild(wrap);
    likesChartsHost.appendChild(card);

    // SHORT axis labels
    const labels = zoneIds.map(zoneShortLabel);

    const data = zoneIds.map(zid => {
      const row = likesSummaryRows.find(r =>
        Number(r.configuration_id) === Number(cfgId) &&
        Number(r.zone_id) === Number(zid)
      );
      return row ? (Number(row.cnt) || 0) : 0;
    });

    const chart = new Chart(canvas, {
      type: 'bar',
      plugins: [ChartDataLabelsPlugin],
      data: {
        labels,
        datasets: [{ label: 'polubienia', data, backgroundColor: '#f15c63' }]
      },
      options: {
        ...chartOptions,
        layout: { padding: { top: 24 } },
        plugins: {
          legend: { display: false },
          datalabels: {
            color: '#1a1818',
            font: { size: 12, weight: 'bold' },
            anchor: 'end',
            align: 'top',
            formatter: v => v || ''
          },
          // Long label ONLY on hover (tooltip)
          tooltip: {
            callbacks: {
              title: (items) => {
                if (!items?.length) return '';
                const idx = items[0].dataIndex;           // bar index
                const zid = zoneIds[idx];                 // numeric zone id
                return zoneLikesGraphLabel(cfgId, zid);   // "Strefa N: <text>"
              },
              label: (item) => `polubienia: ${item.parsed.y}`
            }
          }
        },
        scales: {
          x: { ticks: { autoSkip: false } },
          y: { beginAtZero: true, max: GLOBAL_LIKES_MAX, ticks: { precision: 0, stepSize: 1 } }
        }
      }
    });

    charts.push(chart);
    likesCharts.push(chart);
    resultsObserver?.observe(wrap);
  });

  resultsInitiated?.();
}



async function fetchLikesSummary() {
  try {
    const res = await fetch(LIKES_ENDPOINT);
    const rows = await res.json();
    if (!Array.isArray(rows)) return;

    likesSummaryRows = rows.map(r => ({
      configuration_id: Number(r.configuration_id),
      zone_id: Number(r.zone_id),
      cnt: Number(r.cnt)
    }));

    buildLikesCharts();
  } catch (e) {
    console.error('Błąd pobierania polubień:', e);
  }
}

// Refresh only the likes summary + re-animate likes charts if stats tab is visible
function refreshLikesOnly() {
  fetchLikesSummary().then(() => {
    const statsVisible = !document.getElementById('statistics-container')?.classList.contains('hidden');
    if (statsVisible && Array.isArray(window.__likesCharts)) {
      window.__likesCharts.forEach(ch => {
        // trigger animation on the updated likes charts
        ch.reset();
        ch.update();
      });
    }
  });
}
window.refreshLikesOnly = refreshLikesOnly;


function setUpResults() {
    charts.forEach(chart => chart.destroy());
    charts = [];

    setListeners();
    setObservers();

    participantCountSpan.textContent = participantCount;

    const ageChart = new Chart(ageChartCanvas, {
        type: 'bar',
        options: {
            ...chartOptions,
            plugins: {
                legend: {
                    display: false
                },
            },
        },
        data: {
            labels: ageData.map(row => row.ageGroup),
            datasets: [
                {
                    label: 'Odwiedzający według wieku',
                    data: ageData.map(row => row.count),
                    backgroundColor: '#FFD700'
                }
            ]
        }
    });

    const genderChart = new Chart(genderChartCanvas, {
        type: 'pie',
        plugins: [ChartDataLabelsPlugin],
        options: {
            ...chartOptions,
            plugins: {
                datalabels: {
                    formatter: (value, context) => {
                        let percentage = (value / context.chart._metasets
                        [context.datasetIndex].total * 100)
                            .toFixed(0) + '%';
                        return percentage;
                    },
                    color: '#1a1818',
                    font: {
                        size: 17,
                        weight: 'bold'
                    },
                    anchor: 'end',
                    align: 'start',
                    offset: 0,
                }
            }
        },
        data: {
            labels: genderData.map(row => row.gender),
            datasets: [
                {
                    label: 'Odwiedzający według płci',
                    data: genderData.map(row => row.count),
                    backgroundColor: ['#7CB5EC', '#50527aff', '#FFD700', '#90ED7D']
                }
            ]
        }
    });

    const localsChart = new Chart(localsChartCanvas, {
        type: 'bar',
        plugins: [ChartDataLabelsPlugin],
        data: {
            labels: ['lokalni odwiedzający'],
            datasets: [
                {
                    label: 'w pobliżu placu',
                    data: [
                        placeRelationData.localParticipantsNeighbourhood,
                    ],
                    backgroundColor: ['#305BAB']
                },
                {
                    label: 'w Gliwicach',
                    data: [
                        placeRelationData.localParticipantsCity,
                    ],
                    backgroundColor: ['#93A2AE']
                },
            ]
        },
        options: {
            ...chartOptions,
            plugins: placeRelationChartPlugins,
            scales: {
                x: {
                    stacked: true,
                    display: false
                },
                y: {
                    stacked: true,
                    max: placeRelationMax,
                    display: false
                },
            }
        }
    });

    const visitorsChart = new Chart(visitorsChartCanvas, {
        type: 'bar',
        plugins: [ChartDataLabelsPlugin],
        data: {
            labels: ['inni odwiedzający'],
            datasets: [
                {
                    label: 'poza Gliwicami',
                    data: [
                        placeRelationData.otherVisitors,
                    ],
                    backgroundColor: ['#F9D235']
                },
            ]
        },
        options: {
            ...chartOptions,
            plugins: {
                ...placeRelationChartPlugins,
                title: {
                    ...placeRelationChartPlugins.title,
                    text: 'inni odwiedzający',
                }
            },
            scales: {
                x: {
                    stacked: true,
                    display: false
                },
                y: {
                    stacked: true,
                    max: placeRelationMax,
                    display: false
                }
            }
        }
    });

    const sourceChartLocal = new Chart(sourceChartCanvas, {
        type: 'pie',
        plugins: [ChartDataLabelsPlugin],
        options: {
            ...chartOptions,
            plugins: {
                datalabels: {
                    formatter: (value, context) => {
                        const total = context.chart._metasets[context.datasetIndex].total;
                        return ((value / total) * 100).toFixed(0) + '%';
                    },
                    color: '#1a1818',
                    font: { size: 17, weight: 'bold' },
                    anchor: 'end',
                    align: 'start',
                    offset: 0,
                },
                legend: { position: 'bottom' },
                title: {
                    display: true,
                    text: 'źródło odpowiedzi',
                    color: 'black',
                    font: { size: 20, weight: 'bold' },
                    position: 'bottom',
                    align: 'center',
                }
            }
        },
        data: {
            labels: answersSourceData.map(r => r.label),
            datasets: [{
                label: 'ilość osób według źródła',
                data: answersSourceData.map(r => r.count),
                backgroundColor: ['#7CB5EC', '#FFD700']
            }]
        }
    });


    charts = [
        ageChart,
        genderChart,
        localsChart,
        visitorsChart
    ];
    charts.push(sourceChartLocal);
    sourceChart = sourceChartLocal;

    buildLikesCharts();
}

let firstRender = true;
export function resultsInitiated() {
    if (currentTab === null) {
        // Select statistics tab by default
        selectTab('statistics');
    }
    if (currentTab === 'statistics') {
        // Play animations
        charts.forEach(chart => {
            if (!firstRender) {
                chart.reset();
                chart.update();
                return;
            }

            // Discard initial animation
            chart.ctx.canvas.style.visibility = 'hidden';
            chart.reset();
            chart.update('none');

            setTimeout(() => {
                chart.reset();
                chart.update();
                chart.ctx.canvas.style.visibility = 'visible';
            }, 100);
        });
        firstRender = false;
        return;
    }
    if (currentTab === 'gallery') {
        fetchGalleryImages();
    }
}

let selectedQuestionIndex;
function selectQuestion(index) {
    if (selectedQuestionIndex === index) return;
    if (questionText === null) return;

    const question = questionsData[index];
    questionText.classList.add('disappearing');
    setTimeout(() => {
        questionText.textContent = question.question;
        questionText.classList.remove('disappearing');

        questionText.style.transition = 'none';
        questionText.classList.add('appearing');
        questionText.offsetHeight; // trigger reflow
        questionText.style.transition = '';
        questionText.classList.remove('appearing');
    }, 300);

    const questionButtons = document.querySelectorAll('.question-button');
    questionButtons.forEach(btn => btn.classList.remove('selected'));
    questionButtons[index].classList.add('selected');

    questionButtons[index].querySelector('.reply-count').textContent = question.replies;

    const sentimentPercentages = document.querySelectorAll('.sentiment-percent');
    sentimentPercentages.forEach((span, idx) => {
        span.textContent = question.sentiment[idx] + '%';
    });

    const newThemes = question.themes.map((count, idx) => ({
        name: themeNames[idx],
        count: count
    }));

    redrawThemes(newThemes);

    selectedQuestionIndex = index;
}

function updateChartsData() {
    charts[0].data.datasets[0].data = ageData.map(row => row.count);
    charts[0].update();

    charts[1].data.datasets[0].data = genderData.map(row => row.count);
    charts[1].update();

    charts[2].options.scales.y.max = placeRelationMax;
    charts[2].data.datasets[0].data = [placeRelationData.localParticipantsNeighbourhood];
    charts[2].data.datasets[1].data = [placeRelationData.localParticipantsCity];
    charts[2].update();

    charts[3].options.scales.y.max = placeRelationMax;
    charts[3].data.datasets[0].data = [placeRelationData.otherVisitors];
    charts[3].update();

    sourceChart.data.labels = answersSourceData.map(r => r.label);
    sourceChart.data.datasets[0].data = answersSourceData.map(r => r.count);
    sourceChart.update();

}

// Returns the sum of counts for the given labels in the data array
function getCountFromResults(data, ...labels) {
    const wanted = labels.map(norm);
    return data
        .filter(row => wanted.includes(norm(row.label)))
        .reduce((sum, row) => sum + (parseInt(row.cnt, 10) || 0), 0);
}

function fetchResults() {
    fetch('https://publictwin.info/EngagementAppPrototypes/PlacKrakowskiPHP/Get_Results_PlacKrakowski.php')
        .then(r => r.json())
        .then(results => {

            const ageDataRows = results.filter(row => row.dataset === 'age');

            const ageGroups = ["1-14", "15-24", "25-34", "35-44", "45-54", "55-70", "70+"];
            const ageGroupLabels = ["1-14", "15-24", "25-34", "35-44", "45-54", "55-70", "70+"];
            ageData = ageGroups.map((group, index) => ({
                ageGroup: ageGroupLabels[index],
                count: getCountFromResults(ageDataRows, group)
            }));

            const genderDataRows = results.filter(row => row.dataset === 'gender');
            genderData = [
                { gender: 'kobieta', count: getCountFromResults(genderDataRows, 'kobieta') },
                { gender: 'mężczyzna', count: getCountFromResults(genderDataRows, 'mężczyzna') },
                { gender: 'inna', count: getCountFromResults(genderDataRows, 'inna') },
                { gender: 'wolę nie odpowiadać', count: getCountFromResults(genderDataRows, 'wolę nie odpowiadać') },
            ];

            console.log("results", results);
            const placeRelationRows = results.filter(row => row.dataset === 'place');
            calculateGenderRelationSums(genderData); // keeps participantCount up to date

            const neighbourhoodCount = getCountFromResults(placeRelationRows, ...NEIGHBOR_LABELS);
            const cityCount = getCountFromResults(placeRelationRows, ...CITY_LABELS);
            const knownLocalTotal = neighbourhoodCount + cityCount;

            placeRelationData = {
                localParticipantsNeighbourhood: neighbourhoodCount,
                localParticipantsCity: cityCount,
                otherVisitors: Math.max(0, participantCount - knownLocalTotal),
            };



            const sourceRows = results.filter(row => row.dataset === 'answers_source');
            answersSourceData = [
                { label: 'online', count: getCountFromResults(sourceRows, 'app') },
                { label: 'formularz', count: getCountFromResults(sourceRows, 'form') },
            ];

            // keep existing calls:
            calculatePlaceRelationSums();
            updateChartsData();
            participantCountSpan.textContent = participantCount;
            fetchLikesSummary();
        })
        .catch(err => console.error(err));
}

setUpResults();
fetchResults();


// already in your results script:
const debounce = (fn, ms = 250) => {
  let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };
};

function refreshParticipationResults() {
  if (typeof showLoadingScreen === 'function') showLoadingScreen();

  if (typeof fetchResults === 'function') {
    fetchResults();              // this calls fetchLikesSummary() inside once results arrive
  } else if (typeof fetchAnswers === 'function') {
    fetchAnswers();
  }

  if (typeof getActiveConfigurationId === 'function' &&
      typeof getActiveZoneIdInt === 'function' &&
      typeof refreshZoneStatsUI === 'function') {
    const cfgId = getActiveConfigurationId();
    const zoneId = getActiveZoneIdInt();
    if (cfgId && zoneId) refreshZoneStatsUI(cfgId, zoneId);
  }
}

const debouncedRefresh = debounce(refreshParticipationResults, 300);

// ⬇️ expose to other scripts
window.refreshParticipationResults = refreshParticipationResults;
window.debouncedRefresh = debouncedRefresh;

// (optional) react to a custom event fired by the zones UI
document.addEventListener('plac:likes-changed', () => {
  window.debouncedRefresh();
});

document.addEventListener('click', (ev) => {
  const startBtn = ev.target.closest('#UrbanFutureStartExperienceButton');
  if (!startBtn) return;

  debouncedRefresh();
}, { passive: true });